<template>
    <v-container fluid>
        <v-row>
            <h1 style="margin-left: 20px;">廠商名稱:&nbsp;{{vendor_name}}</h1>
        </v-row>
        
        <v-row>
            <doctor-overview :vendor_id="vendor_account_id"></doctor-overview>
        </v-row>
    </v-container>
</template>

<script>
import DoctorOverview from '../pages/DoctorOverview'
export default {
    components:{DoctorOverview},
    data(){
        return {
            vendor_account_id: parseInt(this.$route.query.vid),
            vendor_name: this.$route.query.vendor_name,
        }
    },

}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_600{
    max-width: 600px;
}


</style>